import { useOutletContext } from 'react-router-dom';

/**
 * True when rendered inside the Marketing tab shell (via prop or outlet context).
 */
export function useMarketingEmbedded(propEmbedded = false) {
  const outlet = useOutletContext();
  return Boolean(propEmbedded || outlet?.embedded);
}
